<template>
    <validation-provider :rules="rules" :name="name" v-slot="{errors, required}">
        <v-slider v-bind="$attrs" v-on="$listeners" :error-messages="errors"
        :color="color" track-color="trackColor">
            <slot v-for="(_, name) in $slots" :name="name" :slot="name" />
            <template v-for="(_, name) in $scopedSlots" v-slot:[name]="scope">
                <slot :name="name" v-bind="scope"></slot>
            </template>

            <template #label v-if="label">
                <div :class="[errors.length==0 ? `${color}--text` : '']">
                    {{getLabel(required)}}
                </div>
            </template>
        </v-slider>
    </validation-provider>

</template>
<script>
export default {
    name:"Slider",
    props:{
        rules: {
            type: [Object, String],
            default: ""
        },
        label: {
            type: String
        },
        color:{
            type: String,
            default: "primary"
        },
        name:{
            type: String,
        },
        trackColor:{
            type: String,
            default: "primary"
        }
    },
    methods:{
        getLabel(required){
            if(this.label){
                if (required){
                    return this.label + " *";
                }
                return this.label;
            }
            return undefined;
        }
    }
}
</script>